import { RouterConfig } from '@angular/router';
import { StaffingStandardsComponent } from './staffing-standards.component';
import { StaffingStandardsTraconComponent } from './staffing-standards-tracon/staffing-standards-tracon.component'
import { StaffingStandardsTowerComponent } from './staffing-standards-tower/staffing-standards-tower.component'
import {TowersTraconsImportComponent} from '../towers-tracons-import/towers-tracons-import.component';

export const StaffingStandardsRoutes: RouterConfig = [
  //all staffingstandardsroutes routes here
  {path: 'staffing-standards-tracon', component: StaffingStandardsTraconComponent},
  {path: 'staffing-standards-tower', component: StaffingStandardsTowerComponent},
  {path: 'towers-tracons-import', component: TowersTraconsImportComponent},
];





/** WEBPACK FOOTER **
 ** ./app/system-management/staffing-standards/staffing-standards.routes.ts
 **/